import { StyleSheet, Platform } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

export function getPickStatsScopeToggleStyles(C: WcColors) {
  return StyleSheet.create({
    scopeWrap: {
      marginTop: 18,
      marginHorizontal: 16,
    },
    scopeToggle: {
      flexDirection: 'row',
      backgroundColor: C.panelHi,
      borderRadius: 14,
      padding: 4,
      gap: 4,
      borderWidth: 1,
      borderColor: C.line,
    },
    scopeTab: {
      flex: 1,
      paddingVertical: 10,
      paddingHorizontal: 6,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      gap: 6,
    },
    scopeTabActive: {
      backgroundColor: C.purpleDeep,
      ...(Platform.OS === 'web' && {
        boxShadow: `0 4px 12px ${C.purpleDeep}66` as never,
      }),
    },
    scopeTabText: {
      fontSize: 13,
      fontWeight: '800',
      color: C.inkMute,
    },
    scopeTabTextActive: {
      color: C.textOnPrimary,
    },
    scopeBtnPressed: { opacity: 0.75 },

    // Group dropdown
    groupDropdownWrap: {
      marginTop: 8,
    },
    groupDropdownTrigger: {
      borderRadius: 12,
      backgroundColor: C.panel,
      borderWidth: 1,
      borderColor: C.line,
    },
    groupDropdownTriggerOpen: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomColor: C.lineHi,
    },
    groupDropdownTriggerInner: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 10,
      gap: 10,
    },
    groupDropdownIcon: {
      width: 28,
      height: 28,
      borderRadius: 8,
      backgroundColor: C.purple + '22',
      alignItems: 'center',
      justifyContent: 'center',
    },
    groupDropdownTextContent: {
      flex: 1,
    },
    groupDropdownName: {
      fontSize: 13,
      fontWeight: '700',
      color: C.ink,
    },
    groupDropdownMeta: {
      fontSize: 11,
      color: C.inkDim,
      marginTop: 1,
    },
    groupDropdownList: {
      borderWidth: 1,
      borderTopWidth: 0,
      borderColor: C.line,
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      backgroundColor: C.panelHi,
      overflow: 'hidden',
    },
    groupDropdownItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 12,
      paddingVertical: 10,
      gap: 10,
    },
    groupDropdownItemBorder: {
      borderBottomWidth: 1,
      borderBottomColor: C.line,
    },
    groupDropdownItemTextContent: {
      flex: 1,
    },
    groupDropdownItemName: {
      fontSize: 13,
      fontWeight: '600',
      color: C.inkDim,
    },
    groupDropdownItemNameActive: {
      color: C.ink,
      fontWeight: '700',
    },
    groupDropdownItemMeta: {
      fontSize: 11,
      color: C.inkMute,
      marginTop: 1,
    },
    groupDropdownCheck: {
      width: 18,
      height: 18,
      borderRadius: 9,
      backgroundColor: C.purple,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
}
